import { render, staticRenderFns } from "./ProcessSetToCustomer.vue?vue&type=template&id=abd70ffa&scoped=true"
import script from "./ProcessSetToCustomer.vue?vue&type=script&lang=js"
export * from "./ProcessSetToCustomer.vue?vue&type=script&lang=js"
import style0 from "./ProcessSetToCustomer.vue?vue&type=style&index=0&id=abd70ffa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd70ffa",
  null
  
)

export default component.exports